/**
 * Small coloured pill for the user-status column.
 *
 * Colour mapping mirrors what the dashboard's other status indicators
 * use, so a glance at the table reads the same as the rest of the app.
 */
import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/cn'
import type { UserStatus } from '@/hooks/useAdminUsersApi'

const STYLES: Record<UserStatus, string> = {
  pending:   'bg-amber-faint text-amber',
  active:    'bg-pulse-faint text-pulse',
  suspended: 'bg-rose-faint  text-rose',
  rejected:  'bg-elevated    text-textFaint',
}

export function StatusBadge({ status }: { status: UserStatus }) {
  const { t } = useTranslation('app')
  return (
    <span className={cn('pill', STYLES[status])}>
      {t(`admin.users.status.${status}`)}
    </span>
  )
}
